import { alpha, styled } from '@mui/material/styles'
import { Box, Stack, Typography } from '@mui/material'

export const StackLogo = styled(Stack)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))
export const Title = styled(Typography)(({ theme }) => ({
  color: '#272A30',
  fontFamily: 'Open Sans',
  fontSize: '38.42px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '140%', // ou '53.788px' si tu veux une valeur fixe
  letterSpacing: '-1.153px',
}))
export const Divider = styled(Box)(({ theme }) => ({
  height: '1px',
  width: '47px',
  backgroundColor: '#7C7F81',
  mx: 2,
}))

export const FormBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: '2rem',
  borderRadius: '24px',
  width: '100%',
  maxWidth: '48%',
  margin: '3rem auto',
  [theme.breakpoints.down(900)]: {
    maxWidth: '68%',
  },
  [theme.breakpoints.down(700)]: {
    maxWidth: '90%',
  },
}))
